import React from 'react'
import { FormattedMessage } from 'react-intl'

export const SLOT_CAPTION = (
    <FormattedMessage
        id='slot.caption'
        description='Заголовок над стройплощадкой на ферме'
        defaultMessage='Стройплощадка'
    />
)


// WEBPACK FOOTER //
// ./containers/Stronghold/components/Direction/components/Slot/constants.jsx